import React from "react";
import "./FavoritePage.scss";
import { useSelector, useDispatch } from "react-redux";
import { shopping_cart } from "../../utils/images";
import { Link } from "react-router-dom";
import { formatPrice } from "../../utils/helpers";
import {
  getAllfavorites,
  removeFromfavorite,
  togglefavoriteQty,
  clearfavorite,
  getfavoriteTotal,
} from "../../store/favoriteSlice";
import { IMAGE_URL1 } from "../../utils/apiURL";


const FavoritePage = () => {
  const dispatch = useDispatch();
  const favorites = useSelector(getAllfavorites);
  const { itemsCounts, totalAmount } = useSelector((state) => state.favorite);

  if (favorites.length === 0) {
    return (
      <div className="container my-5">
        <div className="empty-cart flex justify-center align-center flex-column font-manrope">
          <img src={shopping_cart} alt="" />
          <span className="fw-6 fs-15 text-gray">
            Your shopping favorite is empty.
          </span>
          <Link to="/" className="shopping-btn bg-orange text-white fw-5">
            Go shopping Now
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart bg-whitesmoke">
      <div className="container">
        <div className="carts-ctable">
          <div className="cart-chead bg-white">
            <div className="cart-ctr fw-6 font-manrope fs-15">
              <div className="cart-cth">
                <span className="cart-ctxt">Image</span>
              </div>
              <div className="cart-cth">
                <span className="cart-ctxt">Product</span>
              </div>
              <div className="cart-cth">
                <span className="cart-ctxt">Unit Price</span>
              </div>
              <div className="cart-cth">
                <span className="cart-ctxt">Actions</span>
              </div>
            </div>
          </div>

          <div className="cart-cbody bg-white">
            {favorites.map((favorite, idx) => {
              return (
                <div className="cart-ctr py-3" key={favorite?.id}>
                  <div className="cart-ctd">
                    <img
                      src={`${IMAGE_URL1}${favorite?.product_images1}`} // Utiliser la première image du produit
                      alt=""
                      className="img-cover"
                      style={{ width: "70px" }}
                    />{" "}
                  </div>
                  <div className="cart-ctd">
                    <span className="cart-ctxt">{favorite?.product_name}</span>
                  </div>
                  <div className="cart-ctd">
                    <span className="cart-ctxt">
                      {formatPrice(favorite?.price)}
                    </span>
                  </div>
                  <div className="cart-ctd">
                    <button
                      type="button"
                      className="delete-btn text-danger"
                      onClick={() => dispatch(removeFromfavorite(favorite?.id))}
                    >
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-cfoot flex align-start justify-between py-3 bg-white">
            <div className="cart-cfoot-l">
              <button
                type="button"
                className="clear-cart-btn text-danger fs-15 text-uppercase fw-4"
                onClick={() => dispatch(clearfavorite())}
              >
                <i className="fas fa-trash"></i>
                <span className="mx-1">Clear Favorite</span>
              </button>
            </div>

            {/* <div className='cart-cfoot-r flex flex-column justify-end'>
              <div className='total-txt flex align-center justify-end'>
                <div className='font-manrope fw-5'>Total ({itemsCounts}) items: </div>
                <span className='text-orange fs-22 mx-2 fw-6'>{formatPrice(totalAmount)}</span>
              </div>

              <button type = "button" className='checkout-btn text-white bg-orange fs-16'>Check Out</button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FavoritePage;
